// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const munna: PokeData = {
  "id": 517,
  "name": "munna",
  "height": 6,
  "weight": 233,
  "base_experience": 58,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "psybeam",
    "psychic",
    "hypnosis",
    "defense-curl",
    "dream-eater",
    "psywave",
    "nightmare",
    "moonlight",
    "future-sight",
    "magic-coat",
    "yawn",
    "imprison",
    "calm-mind",
    "lucky-chant",
    "zen-headbutt",
    "wonder-room",
    "telekinesis",
    "synchronoise",
    "stored-power",
    "moonblast"
  ],
  "moves": [
    "psychic",
    "psywave",
    "moonlight",
    "future-sight",
    "calm-mind",
    "zen-headbutt",
    "moonblast",
    "prismatic-cage",
    "psy-pulse",
    "kinesis",
    "healing-wish",
    "psy-ball",
    "synchronize"
  ],
  "evolution_chain": {
    "id": 265,
    "item": null,
    "species": [
      {
        "name": "munna",
        "order": 518,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "musharna",
        "order": 519,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 517,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "moon-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 63,
    "speed": 24,
    "ability_power": 67
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
